<template>
  <div class="userBody1">
    <div class="title">
      数据备份
    </div>
    <div class="body">
      <div class="bodyTitle">
        <el-button type="primary" size="small" @click="createData">创建备份</el-button>
      </div>

      <div class="bodyTable">
        <el-table :data="tableData" style="width: 100%"
        :header-cell-style="{background: 'rgb(250,250,250)', color: 'black', fontWeight: '400'}">
          <el-table-column
            prop="number"
            label="备份编号">
          </el-table-column>
          <el-table-column
            prop="path"
            label="备份文件路径">
          </el-table-column>
          <el-table-column
            prop="fileName"
            label="备份文件名称">
          </el-table-column>
          <el-table-column
            prop="backTime"
            label="备份时间">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="备份状态">
            <template slot-scope="{row}">
              <el-tag v-if="row.status === 0" type="danger">正在创建</el-tag>
              <el-tag v-if="row.status === 1" type="success">备份完成</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="{row}">
              <el-link type="primary" v-if="row.status === 1" @click="downloadBtn(row)">下载备份数据</el-link>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pageBox">
          <Page :total="total" :current="curPage" :page-size="limit" 
          @on-change="handleChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataConfigList, createDataBackup } from "@/api/companyManager"
import { downLoadDocument } from "@/api/downLoad"
export default {
  name: 'dataConfig',
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 10,
      curPage: 1,
      timer: null
    }
  },
  methods: {
    // 翻页
    handleChange(val) {
      this.curPage = val
      this.getList()
    },
    // 获取表格数据
    getList() {
      getDataConfigList({ limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    // 创建备份
    createData() {
      createDataBackup({}).then(res => {
        this.getList()
      })
    },
    // 下载文件
    downloadBtn(row) {
      // console.log(row)
      downLoadDocument(row.path, row.fileName)
    }
  },
  created() {
    this.getList()
    this.timer = setInterval(() => {
      this.getList()
    },60000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped>
.title {
  height: 60px;
  width: 100%;
  line-height: 60px;
  background: white;
  padding-left: 25px;
  margin-bottom: 15px
}
.body {
  width: 99%;
  /* height: 300px; */
  background: white;
  margin: auto;
  padding: 15px;
}
.bodyTitle{
  text-align: right;
}
.bodyTable {
  margin-top: 20px
}
.pageBox {
  text-align: right;
  margin-top: 15px;
}
</style>